<template>
  <div>
      <busca-pedido></busca-pedido>
  </div>
</template>

<script>
export default {
  components: {
    "busca-pedido": require("../components/BuscaPedido.vue").default
  }
};
</script>

